import { authApi } from './authApi';
export { authApi };
export default authApi;